<script>
import axios from 'axios'
import Vue from 'vue'
const sha1 = require('sha1')
import LZString144 from '@/models/lzstring'
//import Firebase from '@/models/Firebase'
//import Peer from 'peerjs'
let Api = new Vue({
  name: 'ApiLocalStorage',
  data() {
    return {
      appName: 'Haakon CMMS',
      esBdLocal: true,
      servidor: 'https://app.haakon.mx:8082/test',
      servidorDefault: 'https://app.haakon.mx:8082/test',
      //cdn: 'http://45.55.89.128/cdn/hb3',
      cdn: 'https://cdn.haakon.mx',
      yo: {},
      yoGoogle: {},
      WSTcolecciones: ['Producto', 'Etiqueta'],
      cache: {},
      usarCache: false,
      modoPersistente: false,
      defaultUser: 'admin@local',
      defaultPw: 'password',
      customTokenSource: '',
      localStorageDefaultKey: 'cmms.yo',
      modoProduccion: (process && process.env && process.env.NODE_ENV && process.env.NODE_ENV === 'production'),
      modoOffline: false,
      usarPrecache: false,
      // PeerJS
      peer: null,
      conexionesExistentes: {},
      // Modo localStorage
      prefijo: 'hb3',
      comprimirDatos: true,
      habilitarGeolocalizacion: false
    }
  },
  methods: {
    async login(user, pass, dondeGuardarIdentidad, noReintentar) {
      user = user || ''
      pass = pass || ''
      dondeGuardarIdentidad = dondeGuardarIdentidad || this.localStorageDefaultKey
      noReintentar = noReintentar && true ? true : false
      console.log("LOGIN", user, dondeGuardarIdentidad)
      console.log("Guardando identidad en ", dondeGuardarIdentidad)
      if (dondeGuardarIdentidad != this.localStorageDefaultKey) {
        this.customTokenSource = dondeGuardarIdentidad
      }
      let passOriginal = pass || ''
      if (pass.length != 40)
        pass = sha1(pass || '')
      let vm = this
      let resultado = null
      let error = null
      let jwtable = null
      console.info("Login", user, pass)
      try {
        console.log("Intentando auth directa...")
        let paramsBusquedaUsuario = [
          'email,eq,' + user,
          'password,eq,' + pass
        ]
        let rJWT = (await Api.find('directorio', paramsBusquedaUsuario))
          .concat((await Api.find('usuario', paramsBusquedaUsuario)))
        rJWT = {
          data: rJWT[0]
        }
        rJWT.data.jwt = sha1('Mi vieja mula ya no es lo que era ya no es lo que era ya no es lo que era')
        //let rJWT2 = (await Api.find('usuario', paramsBusquedaUsuario))
        console.log("try?", paramsBusquedaUsuario, rJWT)
        if (rJWT && rJWT.data && rJWT.data._id && rJWT.data.jwt) {
          vm.saveLocal(dondeGuardarIdentidad, rJWT.data)
          // guardar contraseña maestra
          if (rJWT.data.rol && rJWT.data.rol == 'administrador') {
            console.log("Guardando contraseña maestra", (rJWT.data.email))
            this.saveLocal('cmms.wstDefaultUser', user)
            this.saveLocal('cmms.wstDefaultPw', pass)
          }
          resultado = rJWT.data
          console.info("AUTH+JWT", resultado.email, resultado.jwt.length)
        } else {
          throw new Error('Credenciales incorrectas?')
        }
      } catch (e) {
        error = 'Credenciales no encontradas'
      }
      return new Promise(async (resolve, reject) => {
        if (resultado && resultado._id) {
          console.log("CREDENCIALES", resultado)
          // Si está disponible info de una empresa, guardarla de una vez
          try {
            let empresaExistente = await Api.get('empresa') || []
            if (empresaExistente && empresaExistente[0]) {
              vm.saveLocal('cmms.empresastr', empresaExistente[0].nombre)
              vm.saveLocal('cmms.empresadb', empresaExistente[0])
            }
            //
          } catch (e) {}
          resolve(resultado)
        } else {
          console.error("EAPILOCALSTORAGEAUTH", resultado)
          reject({
            error: 'Error de autentificación',
            raw: error
          })
        }
      })
    },
    // Servidor intercambiable
    cambiarServidor(url) /**/ {
      this.servidor = url
      let uurl = new URL(this.servidor)
      if (
        uurl.hostname != window.location.hostname &&
        this.modoProduccion
      ) {
        console.log("Cambiando hostname", window.location.hostname, uurl.hostname)
        this.servidor = this.servidor.replace(uurl.hostname, window.location.hostname).replace(uurl.protocol, window.location.protocol)
      }
      console.log("Cambiada la URL del servidor", this.servidor)
    },
    setServer(url, defaultUser, defaultPw) /**/ {
      this.servidor = url
      if (defaultUser)
        this.defaultUser = defaultUser
      if (defaultPw)
        this.defaultPw = defaultPw
      console.log("Configurado servidor de esta instancia", this.servidor, this.defaultUser)
      //return this.ping()
      return true
    },
    errorHandler(e) /**/ {
      let vm = this
      let text = ''
      if (e && e.text)
        text = ': ' + e.text;
      vm.error = 'Error' + text;
      setTimeout(function() {
        delete vm.error;
      }, 1000);
      //    reject(e || {});
    },
    async saveLocal(lugar, obj) /**/ {
      console.log("saveLocal", lugar, obj)
      if (typeof obj == 'object')
        localStorage.setItem(lugar, JSON.stringify(obj))
      else localStorage.setItem(lugar, obj)
      //
      return true
    },
    fetchLocal(lugar) /**/ {
      let r = null
      try {
        r = JSON.parse(localStorage.getItem(lugar))
      } catch (e) {
        r = localStorage.getItem(lugar)
      }
      return r
    },
    deleteLocal(lugar) /**/ {
      console.log("deleteLocal", lugar)
      localStorage.removeItem(lugar)
    },
    esMovil() /**/ {
      var check = false;
      (function(a) {
        if (
          /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i
          .test(a) ||
          /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i
          .test(a.substr(0, 4))) check = true;
      })(navigator.userAgent || navigator.vendor || window.opera);
      return check;
    },
    wait(time) /**/ {
      time = time || 1000
      return new Promise(resolve => {
        setTimeout(_ => {
          resolve(true)
        }, time)
      })
    },
    ping(str) /**/ {
      return Promise.resolve(true)
    },
    uuid() {
      // TODO remplazar primer mitad del UUID con algo característico del dispositivo o del nombre de la BD
      return 'xxxxxxxxxxxxxxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0,
          v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
      });
    },
    dump(bd) {
      bd = bd || '' // TODO aislar base de datos en modo multibd
      console.error("EWARNDBDUMP", new Date());
      let vm = this;
      return new Promise((resolve, reject) => {
        let ruta = vm.servidor + '/dump';
        axios.post(ruta, null, {
          headers: {
            'wst-appkey': 'vueonic',
            'token': vm.token()
          }
        }).then(function(p) {
          let o = p.data || {};
          if (!o.error)
            resolve(o);
          else
            reject(o);
        })
      })
    },
    token() {
      let t = ''
      let dondeLeerIdentidad = (this.customTokenSource && this.customTokenSource != '') ?
        this.customTokenSource : this.localStorageDefaultKey
      try {
        let k = JSON.parse(localStorage.getItem(dondeLeerIdentidad))
        t = k.jwt || ''
        if (t == null || t == '')
          throw new Error('EHB3TOKEN ' + dondeLeerIdentidad)
      } catch (e) {
        // No se pudo recuperar el token
        let k = JSON.parse(localStorage.getItem('cmms.yo'))
        t = k ? k.jwt : ''
      }
      return t
    },
    get(coleccion, id, subset) /**/ {
      coleccion = (coleccion || '').toLowerCase()
      id = id || ''
      let comprimirDatos = this.comprimirDatos
      let res
      let vm = this
      //console.log("getlocal", coleccion, id, sincrono)
      return new Promise(async (resolve, reject) => {
        try {
          //console.log("ApiLocalStorage get", coleccion, id, id != '')
          let keys = Object.keys(localStorage)
          let results = []
          for (let key of keys) {
            let label = this.prefijo + '.' + coleccion
            if (id != '')
              label += '.' + id
            if (false)
              console.log("ApiLocalStorage comparando", coleccion, key,
                (key.startsWith(label) && key.replace(label + '.', '').length == 24),
                key == label
              )
            if (
              (key.startsWith(label) && key.replace(label + '.', '').length == 24) ||
              key == label
            ) {
              let val = localStorage.getItem(key)
              if (comprimirDatos && !(val.startsWith('{')))
                val = LZString144.decompress(val)
              try {
                val = JSON.parse(val)
                results.push(val)
              } catch (e) {
                // console.error("EJSON", e)
              }
            }
          }
          if (results.length == 0) {
            throw new Error('Objeto no encontrado')
            //console.error("Coleccion vacia", coleccion)
          }
          // Subset
          if (subset && typeof subset == 'object') {
            let paramsRequeridos = ['coleccion', 'query', 'sustituir']
            for (let id in results) {
              for (let sub of subset) {
                // Checar integridad del query del subset
                for (let param of paramsRequeridos)
                  if (!(sub[param] && sub[param].length > 0))
                    throw new Error('Faltan parámetros del subset: ' + param)
                // Construir el query
                let subres, sustituir = results[id][sub.sustituir]
                if (sub.query.startsWith('_id') || sub.unico == true) {
                  subres = await vm.get(sub.coleccion, sustituir)
                } else {
                  let query = sub.query
                  if (!query.endsWith(','))
                    query += ','
                  if (query.split(',').length <= 1)
                    query += ',eq,'
                  subres = await vm.find(sub.coleccion, [query + sustituir])
                }
                // Añadir al objeto del resultado
                results[id][sub.alias || sub.coleccion] = subres
              }
            }
          }
          //
          console.log("Devolviendo", coleccion, id)
          if (
            id != ''
            //&& results.length == 1
          ) {
            res = results[0]
          } else {
            res = results
          }
          // console.log("results?", coleccion, res)
          resolve(res)
        } catch (e) {
          let yoGoogle = this.fetchLocal('cmms.firebaseAuth') || {}
          if (!yoGoogle.credential)
            console.error("EGET", e)
          else
            console.info("EGET", e)
          if (id == '') {
            res = []
            resolve(res) // Devolver coleccion vacia, es valor posible
          } else {
            console.error("EAPILOCALSTORAGENOTFOUND", coleccion, id, e)
            res = { // Devolver objeto no encontrado
              error: e
            }
            reject(res)
          }
        }
      })
    },
    async find(coleccion, params, opciones) /**/ {
      let resultados = await this.get(coleccion)
      console.log("find resultados sin filtrar?", resultados)
      params = params || []
      opciones = opciones || {}
      let vm = this
      // Filtrar por parámetros
      if (params.length > 0) {
        for (let parametro of params) {
          // Parametrizar el filtro
          let campo = parametro.split(',')[0]
          let operador = parametro.split(',')[1]
          let valor = parametro.split(',')[2]
          // Limpieza de valores
          if (['gt', 'gte', 'lt', 'lte'].indexOf(operador) >= 0 && !isNaN(valor))
            valor = parseFloat(valor)
          if (valor == 'null')
            valor = null
          // Aplicar el filtro
          resultados = resultados.filter(r => {
            let mostrar = true
            let valorEnCampo = r[campo]
            switch (operador) {
              case 'eq':
              case 'equals':
                mostrar = (valorEnCampo == valor)
                break
              case 'gt':
                mostrar = (valorEnCampo > valor)
                break
              case 'gte':
                mostrar = (valorEnCampo >= valor)
                break
              case 'lt':
                mostrar = (valorEnCampo < valor)
                break
              case 'lte':
                mostrar = (valorEnCampo <= valor)
                break
              case 'contains':
              case 'cs':
                mostrar = (valorEnCampo.indexOf(valor) >= 0)
                break
              case 'ne':
                mostrar = (valorEnCampo != valor)
                break
              default:
                console.warn("No se reconoce el operador", operador)
                mostrar = false
                break
            }
            return mostrar
          })
        }
      }
      // Configuracion de resultados
      if (opciones.sort) {
        let sort = opciones.sort
        if (typeof sort == 'string')
          sort = [sort]
        for (let ordenable of sort) {
          let campo = ordenable.split(',')[0]
          let sentido = ordenable.split(',')[1]
          resultados = resultados.sort((a, b) => {
            if (sentido == 1 || sentido == '1')
              return (a[campo] > b[campo]) ? 1 : -1
            else
              return (a[campo] < b[campo]) ? 1 : -1
          })
        }
      }
      if (opciones.skip && !isNaN(opciones.skip))
        resultados = resultados.splice(opciones.skip, resultados.length)
      if (opciones.limit && !isNaN(opciones.limit))
        resultados = resultados.slice(0, opciones.limit)
      if (opciones.subset && typeof opciones.subset == 'object') {
        console.log("subset", coleccion, params, opciones.subset)
        let paramsRequeridos = ['coleccion', 'query', 'sustituir']
        for (let id in resultados) {
          for (let sub of opciones.subset) {
            // Checar integridad del query del subset
            for (let param of paramsRequeridos)
              if (!(sub[param] && sub[param].length > 0))
                throw new Error('Faltan parámetros del subset: ' + param)
            // Construir el query
            let subres, sustituir = resultados[id][sub.sustituir]
            if (sub.query.startsWith('_id') || sub.unico == true) {
              if (sustituir)
                subres = await vm.get(sub.coleccion, sustituir)
              else {
                console.log("subset get sustituir nulo?", coleccion, sub.coleccion, sustituir)
                subres = {}
              }
            } else {
              let query = sub.query
              if (!query.endsWith(','))
                query += ','
              if (query.split(',').length <= 1)
                query += ',eq,'
              let filtrossubset = [query + sustituir]
              console.log("subset find", sub.coleccion, filtrossubset)
              subres = await vm.find(sub.coleccion, filtrossubset)
            }
            // Añadir al objeto del resultado
            console.log("subset subres", coleccion, sub.alias || sub.coleccion, subres)
            resultados[id][sub.alias || sub.coleccion] = subres
          }
        }
      }
      // Listo
      return Promise.resolve(resultados)
    },
    save(coleccion, obj) /**/ {
      coleccion = (coleccion || '').toLowerCase()
      obj = obj || {}
      let comprimirDatos = (this.comprimirDatos == true)
      console.log("savelocal", coleccion, obj)
      return new Promise((resolve, reject) => {
        if (typeof obj != 'object')
          reject({
            error: 'El recurso a guardar no es un objeto'
          })
        else if (coleccion == 'error')
          resolve({
            msg: 'No se sincronizarán errores en modo Offline'
          })
        else try {
          let id = (obj && obj._id && obj._id != '') ? obj._id : this.uuid()
          let label = this.prefijo + '.' + coleccion + '.' + id
          let resource
          if (typeof obj == 'object') {
            obj._id = id
            obj.version = new Date().getTime()
            resource = JSON.stringify(obj)
            console.log("save comprimirDatos", comprimirDatos)
            if (true == comprimirDatos) {
              resource = LZString144.compress(resource)
            }
          }
          localStorage.setItem(label, resource)
          resolve(obj)
        } catch (e) {
          console.error("EAPILOCALSTORAGESAVE", e)
          reject({
            error: 'No se pudo guardar localmente',
            raw: e
          })
        }
      })
    },
    saveMulti(coleccion, objs) /**/ {
      coleccion = (coleccion || '').toLowerCase()
      objs = objs || {}
      let comprimirDatos = (this.comprimirDatos == true)
      console.log("savelocal", coleccion, obj)
      let vm = this
      return new Promise((resolve, reject) => {
        if (coleccion == 'error')
          resolve({
            msg: 'No se sincronizarán errores en modo Offline'
          })
        else try {
          for (let obj of objs) {
            let id = (obj && obj._id && obj._id != '') ? obj._id : vm.uuid()
            let label = vm.prefijo + '.' + coleccion + '.' + id
            let resource
            if (typeof obj == 'object') {
              obj._id = id
              obj.version = new Date().getTime()
              resource = JSON.stringify(obj)
              console.log("save comprimirDatos", comprimirDatos)
              if (true == comprimirDatos) {
                resource = LZString144.compress(resource)
              }
            }
            localStorage.setItem(label, resource)
          }
          resolve(objs)
        } catch (e) {
          console.error("EAPILOCALSTORAGESAVE", e)
          reject({
            error: 'No se pudo guardar localmente',
            raw: e
          })
        }
      })
    },
    delete(coleccion, id) /**/ {
      return new Promise((resolve, reject) => {
        try {
          let label = this.prefijo + '.' + coleccion + '.' + id
          localStorage.removeItem(label)
          resolve(true)
        } catch (e) {
          console.error("EAPILOCALSTORAGEDELETE", e)
          reject(true)
        }
      })
    },
    async deleteMulti(modelo, lista) /**/ {
      lista = lista || [];
      modelo = modelo || "";
      let label = this.prefijo + '.' + modelo + '.'
      for (let localKey of Object.keys(localStorage))
        for (let id of lista)
          if (label + id == localKey)
            await Api.delete(modelo, id)
      return Promise.resolve(true)
    },
    // geolocalizacion
    geolocate() /**/ {
      let y = Api.fetchLocal('cmms.yo') || {}
      let vm = this
      return new Promise(async (resolve, reject) => {
        if ('geolocation' in navigator &&
          y &&
          y._id &&
          vm.habilitarGeolocalizacion) {
          navigator.geolocation.getCurrentPosition(async (pos) => {
              let c = {
                rol: y.rol || 'invitado',
                userid: y._id || '',
                lat: pos.coords.latitude,
                long: pos.coords.longitude,
                date: new Date().getTime(),
                route: window.location.hash
              }
              let u = null
              u = await Api.save('geo', c)
              console.log("Guardado geolocalizacion", u)
              resolve(u)
            },
            (e) => {
              reject({
                error: 'No se pudo obtener la ubicación',
                raw: e
              })
            })
        } else {
          reject('No se pudo acceder al módulo de geolocalización')
        }
      })
    },
    // PeerJS
    obtenerPeerConfig() /**/ {
      let urlApi = new URL(this.servidor)
      let peerConfig = {
        host: urlApi.hostname,
        port: parseInt(urlApi.port) + 10,
        path: '/peerserver',
        secure: urlApi.protocol.indexOf('https') >= 0,
        debug: 2
      }
      return peerConfig
    },
    async crearPar() /**/ {
      let yoId = this.fetchLocal('cmms.yo')._id
      let par = new Peer(yoId, this.obtenerPeerConfig())
      console.log("crearPar?", yoId, par)
      return Promise.resolve(par)
    },
    async crearConexionPeer(idDestino) /**/ {
      let vm = this
      let yoId = this.fetchLocal('cmms.yo')._id
      console.log("peer crearPar", yoId, "=>", idDestino)
      try {
        if (!this.peer) {
          //this.peer = await this.crearPar()
          this.peer = new Peer(yoId, this.obtenerPeerConfig())
          console.log("peer par creado ", this.peer)
        }
        let conn = this.peer.connect(idDestino)
        //if (false)
        conn.on('open', _ => {
          conn.send('Hi!')
        })
        this.peer.on('connection', conn => {
          console.log("PeerJS connection", idDestino)
          conn.on('data', data => {
            vm.$emit('PeerJS.data.' + idDestino, data)
          })
          conn.on('open', _ => {
            vm.$emit('PeerJS.open', idDestino)
            console.log("peerjs open", idDestino)
            //conn.send(idDestino, 'peer hola tu')
          })
          if (!vm.conexionesExistentes[idDestino]) {
            vm.$on('PeerJS.send.' + idDestino, (msg) => {
              console.log("$on PeerJS.send." + idDestino, msg.length)
              conn.send(msg)
            })
            vm.conexionesExistentes[idDestino] = true
          }
        })
        this.peer.on('disconnect', _ => {
          console.error("peer Par desconectado", idDestino)
          vm.$off("PeerJS.send." + idDestino)
          while (vm.peer.disconnected)
            setInterval(_ => {
              vm.peer.reconnect()
            }, 5000)
          //vm.peer = null
        })
        console.info("Para recibir datos, usar $on PeerJS.data." + idDestino)
        return Promise.resolve(conn)
      } catch (e) {
        console.error("EPEER", e)
        return Promise.reject(e)
      }
    },
    /* A partir de aqui las funciones todas operan contra API */
    // Upload y download
    upload(handler, devolver) {
      let vm = this
      handler = handler || ''
      devolver = devolver || ''
      return new Promise(async (resolve, reject) => {
        if (['', 'binario', 'base64'].indexOf(devolver) == -1)
          reject('Valor de devolución no valido ("", binario o base64)')
        else if (handler == '')
          reject('Debes especificar un query DOM en el primer argumento')
        var identificador = handler;
        let domHandler = document.querySelector(identificador)
        if (domHandler == null)
          domHandler = document.querySelector('#' + identificador)
        console.log("Cargando archivo del identificador", identificador, domHandler);
        let h = domHandler.files[0];
        var fr = new FileReader();
        if (devolver == 'base64')
          fr.readAsDataURL(h);
        else
          //  fr.readAsBinaryString(h);
          fr.readAsArrayBuffer(h);
        fr.onloadend = async () => {
          let binario = fr.result
          console.log("Bin", handler, binario)
          let ruta = vm.servidor + '/upload'
          if (devolver != '')
            resolve(binario)
          else
            try {
              let k = await Firebase.storageSave(h.name, binario)
              console.log("api upload rutaArchivo?", k)
              let rutaArchivo = await Firebase.storageGet(h.name, true)
              console.log("api upload rutaArchivo", rutaArchivo)
              resolve(rutaArchivo)
            } catch (e) {
              reject(e)
            }
          console.info("FileReader", h);
        }
      })
    },
    // Rotator
    rotator(foto) {
      let vm = this
      return new Promise((resolve, reject) => {
        if (foto.indexOf(vm.cdn) >= 0)
          foto = foto.replace(vm.cdn + '/', '')
        console.log("Pidiendo rotación de", foto)
        if (!foto || foto == '')
          reject({
            error: 'No fue especificada la foto a girar'
          })
        axios.post(vm.servidor + '/rotator', {
          img: foto
        }, {
          headers: {
            'wst-appkey': 'vueonic',
            'token': vm.token()
          }
        }).then(p => {
          if (p && p.data && p.data.nombre)
            resolve(p.data.nombre)
          else reject({
            error: 'No se pudo obtener la nueva imagen rotada',
            raw: p
          })
        }).catch(e => {
          reject({
            error: 'No se pudo recuperar la imagen rotada',
            raw: e
          })
        })
      })
    },
    // Thumbnailer. Para ApiLocalStorage, no se reduce el tamaño
    thumbnailer(handler, ratio, nombre, tamano, devolver) {
      console.log("thumbnailer no está disponible. Subiendo imagen completa.", handler)
      return this.upload(handler)
    },
    // Archivos
    download(str) {
      let ruta = (str.indexOf('http') >= 0) ? this.servidor + '/download/' + str : str
      if (!this.modoOffline) {
        return axios.get(ruta, {
          headers: {
            'wst-appkey': 'vueonic',
            'token': vm.token()
          }
        })
      } else {
        return Promise.reject({
          error: 'No se puede usar el CDN en modo Offline'
        })
      }
    },
    downloadBase64(ruta) {
      let vm = this
      if (!this.modoOffline) {
        return new Promise((resolve, reject) => {
          vm.download(ruta).then(obj => {
            let header = 'data:application/binary;base64,'
            resolve(header + obj.data.data)
          }, err => {
            reject(err)
          })
        })
      } else {
        return Promise.reject({
          error: 'No se puede usar el CDN en modo Offline'
        })
      }
    },
    downloadForce(ruta) {
      let vm = this
      if (!this.modoOffline) {
        vm.downloadBase64(ruta).then(blob => {
          let a = document.createElement('a')
          a.href = blob
          a.download = ruta
          a.style.display = 'none'
          a.style.visibility = 'hidden'
          document.querySelector('body').appendChild(a)
          a.click()
        })
      } else {
        return Promise.reject({
          error: 'No se puede usar el CDN en modo Offline'
        })
      }
    },
    // Crypto
    cryptoCreate(identity, passphrase, length, saveInDb) {
      let ruta = this.servidor + '/crypto/create'
      return axios.post(ruta, {
        identity,
        passphrase,
        length,
        saveInDb,
        idAutor: (this.fetchLocal('cmms.yo')) || {}._id
      })
    },
    cryptoGrant(source, destination, files) {
      let ruta = this.servidor + '/crypto/create'
      return axios.post(ruta, {
        source,
        destination,
        files
      })
    },
    cryptoRequest(source, destination, files) {
      let ruta = this.servidor + '/crypto/request'
      return axios.post(ruta, {
        source,
        destination,
        files
      })
    },
    cryptoValidate(source, destination, files) {
      let ruta = this.servidor + '/crypto/validate'
      return axios.post(ruta, {
        source,
        destination,
        files
      })
    },
    cryptoLockFile(fileBase64, key, passphrase, source) {
      let ruta = this.servidor + '/crypto/lock'
      let authorId = null
      try {
        let yo = this.fetchLocal('cmms.yo')
        if (yo && yo._id)
          authorId = yo._id
      } catch (e) {}
      return axios.post(ruta, {
        source,
        key,
        passphrase,
        fileBase64,
        idAutor: (this.fetchLocal('cmms.yo')) || {}._id
      })
    },
    cryptoUnlockFile(fileBase64, key, passphrase) {
      let ruta = this.servidor + '/crypto/unlock'
      try {
        let yo = this.fetchLocal('cmms.yo')
        if (yo && yo._id)
          authorId = yo._id
      } catch (e) {}
      return axios.post(ruta, {
        fileBase64,
        key,
        passphrase,
      })
    },
    cryptoShareFile(fileBase64, idAutor, shareId) {
      let ruta = this.servidor + '/crypto/share'
      return axios.post(ruta, {
        fileBase64,
        idAutor,
        shareId
      })
    },
    // Email
    email(obj) {
      console.log("Enviando correo", obj)
      let vm = this
      if (!this.modoOffline) {
        return new Promise(async (resolve, reject) => {
          if (!obj.emailOrigen || !obj.nombreOrigen || !obj.mensaje || !obj.emailDestino)
            reject({
              error: 'Faltan datos',
              raw: "emailOrigen,nombreOrigen,mensaje,emailDestino"
            })
          else try {
            let ruta = this.servidor + "/email"
            axios.post(ruta, obj, {
              headers: {
                'wst-appkey': 'vueonic',
                'token': vm.token()
              }
            }).then(r => {
              resolve(r)
            }).catch(e => {
              reject(e)
            })
          } catch (e) {
            console.error("ECORREO", e)
            reject({
              error: "No se pudo enviar el correo",
              raw: e
            })
          }
        })
      } else {
        return Promise.reject({
          error: 'No se pueden enviar emails en modo Offline'
        })
      }
    },
    // libreofficetopdf
    async libreofficetopdf(archivo) {
      archivo = archivo || ''
      let ruta = this.servidor + '/libreofficetopdf'
      if (archivo == '')
        return Promise.reject({
          error: 'No fue especificado un archivo a convertir'
        })
      else
        return axios.post(ruta, {
          archivo
        })
    },
    // Funciones de cache
    saveCache(modelo, obj) {
      let vm = this
      if (modelo && obj) {
        console.log("Save cache", modelo, (obj._id || ''));
        if (vm.tiempoCache != 0 && modelo && obj._id && obj.fecha) {
          if (
            obj.fecha >= (new Date().getTime() - (vm.tiempoCache)) // Está en rango de tiempo
            ||
            vm.WSTcolecciones.indexOf(modelo) != -1 // La app requiere que sea cacheable
          ) {
            if (!vm.cache[modelo])
              vm.cache[modelo] = {};
            vm.cache[modelo][obj._id] = obj;
          }
        }
      }
    },
    deleteCache(modelo, id) {
      let vm = this
      if (modelo && id && vm.cache[modelo] && vm.cache[modelo][id])
        delete vm.cache[modelo][id];
    },
    //
    proxied(obj) {
      let vm = this
      let ruta = vm.servidor + '/proxied'
      let params = ['url', 'options', 'params']
      // params.REQUEST_TYPE
      for (let param of params)
        if (!obj[param])
          return Promise.reject('Falta el parámetro axios:', param)
      if (!this.modoOffline) {
        return axios.post(ruta, obj, {
          headers: {
            'wst-appkey': 'hummingbird3',
            'token': vm.token()
          }
        })
      } else {
        return Promise.reject({
          error: 'No se puede usar el proxy de aplicaciones en modo Offline'
        })
      }
    },
    qrcode(str) {
      console.log("QR", str)
      let vm = this
      let ruta = vm.servidor + '/qrcode'
      if (!this.modoOffline) {
        return axios.post(ruta, {
          cadena: str
        }, {
          headers: {
            'wst-appkey': 'hummingbird3',
            'token': vm.token()
          }
        })
      } else {
        return Promise.reject({
          error: 'No se puede usar el módulo QR en modo Offline'
        })
      }
    },
    getfile(modelo, id, campo, descargarComoBinario) {
      modelo = modelo || ''
      id = id || ''
      campo = campo || 'data'
      let binario = (descargarComoBinario == true) ? "1" : "0"
      let vm = this
      let ruta = vm.servidor + ['/getfile', modelo, id, campo, binario].join('/')
      console.log("getfile", ruta)
      if (!this.modoOffline) {
        return axios.get(ruta, {
          headers: {
            'wst-appkey': 'hummingbird3',
            'token': vm.token()
          }
        })
      } else {
        return Promise.reject({
          error: 'No se pudo recuperar el archivo'
        })
      }
    },
    //
    async procesarUsuarioGoogle(u) {
      console.log("gdrive procesarUsuarioGoogle?", JSON.stringify(u))
      try {
        let usuario = {
          empesa: 'local',
          rol: 'administrador',
        }
        for (let prop in u) {
          if (typeof u[prop] == 'string') {
            console.log("detectado id", u[prop])
            usuario.googleId = u[prop]
          } else {
            for (let prop2 in u[prop]) {
              //u[prop][prop2] = (u[prop][prop2] || '').toString()
              if (typeof u[prop][prop2] == 'string') {
                console.log("prop?", prop, prop2, u[prop][prop2])
                if (u[prop][prop2].indexOf('@') >= 1) {
                  console.log("detectado email", u[prop][prop2])
                  usuario.email = u[prop][prop2]
                }
                if (u[prop][prop2].indexOf('googleusercontent') >= 1) {
                  console.log("detectada imagen", u[prop][prop2])
                  usuario.imagen = u[prop][prop2]
                }
                if (u[prop][prop2].startsWith('eyJ')) {
                  console.log("detectado token", u[prop][prop2])
                  usuario.jwt = u[prop][prop2]
                }
                if (u[prop][prop2].startsWith('ya29') || prop == 'access_token') {
                  console.log("detectado token", u[prop][prop2])
                  usuario.access_token = u[prop][prop2]
                }
                if (prop2.length == 2 && u[prop][prop2].split(' ').length >= 2) {
                  console.log("detectado nombre", u[prop][prop2])
                  usuario.nombre = u[prop][prop2]
                }
              }
            }
          }
        }
        console.log("Usuario construido", usuario)
        usuario._id = sha1(usuario.email || '').substring(0, 24)
        usuario.password = sha1('password')
        usuario = await Api.save('directorio', usuario)
        return Promise.resolve(usuario)
      } catch (e) {
        console.error(e)
        return Promise.reject(e)
      }
    }
  },
  async created() {
    this.comprimirDatos = this.modoProduccion
    // Recuperar servidor de un inicio de sesion previo
    let servidor = this.fetchLocal('cmms.servidor')
    this.modoOffline = this.fetchLocal('cmms.modoOffline') || false
    console.log("Api de WanShiTong", {
      modoProduccion: this.modoProduccion,
      modoOffline: this.modoOffline
    })
    if (servidor && servidor.length > 0) {
      this.servidor = servidor
      console.log("Configurado servidor custom", this.servidor)
    }
    // Configurar servidor a origen externo si no viene de dominio
    // Si Hummingbird no corre desde su dominio, convertir la URL a la IP local
    if (this.modoProduccion && window.location.href.indexOf('haakon.mx') == -1) {
      let hostname = window.location.hostname
      if (hostname == '0.0.0.0')
        hostname = 'localhost'
      //this.servidor = window.location.protocol + '//' + hostname + ':8082'
      this.servidorDefault = this.servidorDefault.replace('https:', window.location.protocol).replace('app.haakon.mx', hostname)
      this.servidor = this.servidorDefault
      console.log("configurando servidor", this.servidor, this.servidorDefault)
    }
    // Modo pruebas
    try {
      let modoPruebas = Api.fetchLocal('cmms.modoPruebas')
      if (modoPruebas && modoPruebas == true) {
        this.modoProduccion = false
        console.log("Forzado modo pruebas")
      }
    } catch (e) {}
    // Hacer un ping para comprobar que todo ande bien. Pero sólo hacia Internet.
    let yoGoogle = this.fetchLocal('cmms.firebaseAuth')
    if (!(yoGoogle && yoGoogle.credential))
      try {
        console.log("localStorage Ping?", this.servidor, this.servidorDefault)
        //if (window.location.hostname.indexOf('haakon.mx') >= 0)
        await this.ping()
      } catch (e) {
        console.warn("Error al hacer PING de inicialización de WanShiTong")
        console.warn(e.response)
        if ((e.response || {}).status == 401) {
          let vm = this
          setTimeout(_ => {
            console.log("$emit esNecesarioHacerLoginNuevamente")
            vm.$emit('esNecesarioHacerLoginNuevamente', true)
          }, 2500)
        }
      }
    // Configurar el inicio de dispositivo
    if (localStorage.getItem('cmms.engine') == 'localStorage') {
      let usuariosExistentes = (await this.get('directorio')).concat((await this.get('usuario')))
      if (usuariosExistentes.length == 0) {
        let usuarioDefault = {
          email: Api.defaultUser,
          nombre: 'Administrador',
          password: sha1(Api.defaultPw),
          rol: 'administrador',
          fechaAlta: new Date().getTime()
        }
        let u = await Api.save('directorio', usuarioDefault)
        Api.saveLocal('cmms.yo', u)
        toast("Bienvenido. Se ha creado el usuario predeterminado.")
      } else {
        console.log("Usuarios encontrados?", usuariosExistentes.length)
      }
    }
  },
  beforeDestroy() {
    if (this.peer) {
      if (typeof this.peer.disconnect == 'function')
        this.peer.disconnect()
    } else {
      this.peer = null
    }
  }
});
window.Api = Api
export default Api
export {
  Api as ApiInstantiable
}
</script>
